<div class="form" [ngSwitch]="platform">
    <form *ngSwitchCase="'desktop'" (submit)="$event.preventDefault()">
        <div class="install-wrapper">
            <div class="title">Get the App</div>

            <div class="text-center" style="margin-bottom: 32px">
                <img src="../../../assets/img/app_icon.png" alt="App Logo" width="96" height="96" class="install-icon"/>
                <div class="install-caption">15th Club Golf GPS Rangefinder</div>
            </div>

            <div class="install-text-important text-center">Scan QR code to download 15th Club</div>

            <div class="text-center" style="margin-top: 16px; margin-bottom: 16px">
                <img [src]="desktopInstallQrData" alt="QR code to download 15th Club" width="240" height="240" class="install-qr"/>
            </div>

            <p class="text-center">Or search for 15th Club in Google Play or App Store</p>
            <p class="text-center">
                <a [href]="getAndroidInstallUrl()" target="_blank" rel="noopener">Google Play</a>
                &middot;
                <a [href]="getIosInstallUrl()" target="_blank" rel="noopener">App Store</a>
            </p>
        </div>
    </form>

    <form *ngSwitchCase="'ios'" (submit)="startIosInstall(true); $event.preventDefault()">
        <div class="install-wrapper">
            <div class="title">Get the App</div>

            <div class="text-center" style="margin-bottom: 32px">
                <img src="../../../assets/img/app_icon.png" alt="App Logo" width="96" height="96" class="install-icon"/>
                <div class="install-caption">15th Club Golf GPS Rangefinder</div>
            </div>

            <div class="install-text-important text-center">Tap below to copy a link — once the app’s installed, we’ll take you to the right place automatically.</div>

            <button type="submit" class="button install-action" [disabled]="isLoading">
                <span [hidden]="isLoading">Install</span>
                <img src="../../../assets/img/spinner.svg" alt="Loading" [hidden]="!isLoading"/>
            </button>

            <div class="text-center install-alt-action">
                <span class="link" (click)="startIosInstall(false)">Continue without copying</span>
            </div>
        </div>
    </form>

    <form *ngSwitchCase="'android'" (submit)="$event.preventDefault()">
        <div class="install-wrapper">
            <div class="title">Get the App</div>

            <div class="text-center" style="margin-bottom: 32px">
                <img src="../../../assets/img/app_icon.png" alt="App Logo" width="96" height="96" class="install-icon"/>
                <div class="install-caption">15th Club Golf GPS Rangefinder</div>
            </div>

            <div class="install-text-important text-center">Redirecting to Google Play…</div>

            <p class="text-center">If it doesn't open automatically, tap below.</p>
            <p class="text-center">
                <a [href]="getAndroidInstallUrl()" rel="noopener">Open Google Play</a>
            </p>
        </div>
    </form>
</div>
